import { AUTHENTICATE, LOGOUT, SETNAVIGATE, LOADINGHOME } from "./actionTypes";

export const setLoadingHome = (payload) => {
	return {
		type: LOADINGHOME,
		payload: payload,
	};
};
export const setNavigate = (payload) => {
	return {
		type: SETNAVIGATE,
		payload: payload,
	};
};
export const authenticate = (payload) => {
	return {
		type: AUTHENTICATE,
		payload: payload,
	};
};
export const logoutStore = () => {
	return {
		type: LOGOUT,
	};
};
